module.exports = __webpack_public_path__ + "static/media/NishmaMaskey.b8e95300.pdf";